<script>
import GenericCustomMasterDataAutocompleteV2 from '@/components/generic/GenericCustomMasterDataAutocompleteV2.vue'
import Utils from '@/common/Utils';
import Constants from '@/common/Constants';
import LabelField from '@/components/generic/LabelField.vue';
export default {
    components: { GenericCustomMasterDataAutocompleteV2, LabelField },
    props: ['proposal', 'actual'],
    emits: [ 'applyProposal' ],
    data(){
        return {
            proposalApplyAllRecords: {}
        }
    },
    mounted(){
        this.createData();
    },
    created(){
    },
    methods: {
        createData(){
            this.proposalApplyAllRecords = {
                // idRegistryVessel: null,
                // vesselApply: true,

                idRegistryInspector: null,
                inspectorApply: true,
                
                laycanStartDateApply: true,
                laycanStartDate: Utils.dateToCurrentTimeZone(this.proposal.loadingDateRangeFrom),
                
                laycanEndDateApply: true,
                laycanEndDate: Utils.dateToCurrentTimeZone(this.proposal.loadingDateRangeTo),

                demurrageApply: true,
                demurrageRateValue: this.proposal.demurrageRateValue,
                demurrageRateCurrency: this.proposal.demurrageRateCurrency,
                demurrageRateUom: this.proposal.demurrageRateUom,
            };
        },
        // onVesselSelected(data){
        //   this.proposalApplyAllRecords.vessel = data.label;
        // },
        onInspectorSelected(data){
          this.proposalApplyAllRecords.inspector = data.label;
        },
        emitApply(){
          //this.proposalApplyAllRecords.vessel = this.$refs.proposalOpVesselCombo.getCompleteValue() ? this.$refs.proposalOpVesselCombo.getCompleteValue().label : "";
          this.proposalApplyAllRecords.inspector = this.$refs.proposalOpInspectorCombo.getCompleteValue() ? this.$refs.proposalOpInspectorCombo.getCompleteValue().label : "";
          this.$emit("applyProposal", this.proposalApplyAllRecords);
        }
    },
    computed: {
        utils: () => Utils,
        constants: () => Constants,
        actualDemurrage(){
          return (this.actual.demurrageRate ?? '') + ' ' + (this.actual.currencyCode ?? '') + ' / ' + (this.actual.laytimeUoMCode ?? '');
        }
    }
}

</script>

<template>
  <!-- <Card class="m-1">
    <template #title>{{$t('vessel.fk')}}</template>
    <template #content>
      <div class="grid">
        <div class="col-12 lg:col-6">
          <LabelField class="w-full mt-1" label="Attuale" :value="actual.vessel" /> 
          <LabelField class="w-full mt-1" label="Email" :value="proposal.vesselName" /> 
        </div>
        <div class="col-10 lg:col-5">
          <GenericCustomMasterDataAutocompleteV2
              v-model="proposalApplyAllRecords.idRegistryVessel"
              :changeFn="onVesselSelected"
              ref="proposalOpVesselCombo"
              :queryValue="proposal.vesselName"
              name="vessel-nomination-vessel-combo"
              api="masterdata/vessel-combo?getOnlyValid=true"
              :class="{'w-full p-inputtext-sm mt-1 ': true}" />
        </div>
        <div class="col-2 lg:col-1 field pt-4">
          <Checkbox v-model="proposalApplyAllRecords.vesselApply" :binary="true" />
        </div>
      </div>
    </template>
  </Card> -->

  
<Card class="m-1">
  <template #title>{{$t('inspector.fk')}}</template>
  <template #content>
    <div class="grid">
      <div class="col-12 lg:col-6">
        <LabelField class="w-full mt-1" label="Attuale" :value="actual.inspector" /> 
        <LabelField class="w-full mt-1" label="Email" :value="proposal.inspectors" /> 
      </div>
      <div class="col-10 lg:col-5">
        <GenericCustomMasterDataAutocompleteV2
            v-model="proposalApplyAllRecords.idRegistryInspector" 
            :changeFn="onInspectorSelected"
            :queryValue="proposal.inspectors"
            ref="proposalOpInspectorCombo"
            name="vessel-nomination-inspectors" 
            api="masterdata/inspector-combo"
            :class="{'w-full p-inputtext-sm mt-1 ': true}" />
      </div>
      <div class="col-2 lg:col-1 field pt-4">
        <Checkbox v-model="proposalApplyAllRecords.inspectorApply" :binary="true" />
      </div>
    </div>
  </template>
</Card>
  
<Card class="m-1">
  <template #title>{{$t('movementInstructions.laycanFrom')}}</template>
  <template #content>
    <div class="grid">
      <div class="col-12 lg:col-6">
        <LabelField class="w-full mt-1" label="Attuale" :value="utils.formatDateTime(utils.dateToCurrentTimeZone(actual.laycanStartDate))" /> 
        <LabelField class="w-full mt-1" label="Email" :value="utils.formatDateTime(utils.dateToCurrentTimeZone(proposal.loadingDateRangeFrom))" /> 
      </div>
      <div class="col-10 lg:col-5">
        <Calendar 
          :placeholder="constants.DATE_PLACEHOLDER_POINT"
          :dateFormat="constants.DATE_FORMAT_POINT"
          :showTime="true" :hideOnDateTimeSelect="true"
          v-model="proposalApplyAllRecords.laycanStartDate"
          :showIcon="true" :showButtonBar="true" :yearNavigator="true"
          :class="{'w-full p-inputtext-sm mt-1 ': true}" />
      </div>
      <div class="col-2 lg:col-1 field pt-4">
        <Checkbox v-model="proposalApplyAllRecords.laycanStartDateApply" :binary="true" />
      </div>
    </div>
  </template>
</Card>
  
<Card class="m-1">
  <template #title>{{$t('movementInstructions.laycanTo')}}</template>
  <template #content>
    <div class="grid">
      <div class="col-12 lg:col-6">
        <LabelField class="w-full mt-1" label="Attuale" :value="utils.formatDateTime(utils.dateToCurrentTimeZone(actual.laycanEndDate))" /> 
        <LabelField class="w-full mt-1" label="Email" :value="utils.formatDateTime(utils.dateToCurrentTimeZone(proposal.loadingDateRangeTo))" /> 
      </div>
      <div class="col-10 lg:col-5">
        <Calendar 
          :placeholder="constants.DATE_PLACEHOLDER_POINT"
          :dateFormat="constants.DATE_FORMAT_POINT"
          :showTime="true" :hideOnDateTimeSelect="true"
          v-model="proposalApplyAllRecords.laycanEndDate"
          :showIcon="true" :showButtonBar="true" :yearNavigator="true"
          :class="{'w-full p-inputtext-sm mt-1 ': true}" />
      </div>
      <div class="col-2 lg:col-1 field pt-4">
        <Checkbox v-model="proposalApplyAllRecords.laycanEndDateApply" :binary="true" />
      </div>
    </div>
  </template>
</Card>
  
  <Card class="m-1">
    <template #title>{{$t('movementInstructions.demurrage')}}</template>
    <template #content>
      <div class="grid">
        <div class="col-12 lg:col-6">
          <LabelField class="w-full mt-1" label="Attuale" :value="actualDemurrage" /> 
          <LabelField class="w-full mt-1" label="Email" :value="proposal.demurrageRate" /> 
        </div>
        <div class="col-10 lg:col-5">
          <InputNumber 
            v-model="proposalApplyAllRecords.demurrageRateValue"
            class="w-full" />
          <GenericCustomMasterDataAutocompleteV2
              v-model="proposalApplyAllRecords.demurrageRateCurrency"
              ref="proposalOpDemurrageRateCurrencyCombo"
              name="vessel-nomination-demurrage-rate-currency-combo"
              api="masterdata/currency-combo"
              :format="{ label: 'name', value: 'isoCode' }" 
              :class="{'w-full p-inputtext-sm mt-1 ': true}" />
          <GenericCustomMasterDataAutocompleteV2
              v-model="proposalApplyAllRecords.demurrageRateUom"
              ref="proposalOpDemurrageRateUomCombo"
              name="vessel-nomination-demurrage-rate-uom-combo"
              api="masterdata/unit-of-measure-combo?scope=MovementInstructionLaytime"
              :class="{'w-full p-inputtext-sm mt-1 ': true}" />
        </div>
        <div class="col-2 lg:col-1 field pt-4">
          <Checkbox v-model="proposalApplyAllRecords.demurrageApply" :binary="true" />
        </div>
      </div>
    </template>
  </Card>
      <Toolbar>
        <template #end>
            <Button class="field m-1" label="Applica Tutti" icon="pi pi-check" variant="outlined"  @click="emitApply" />
        </template>
      </Toolbar>
</template>

